"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketAclInput_1 = require("./PutBucketAclInput");
var PutBucketAclOutput_1 = require("./PutBucketAclOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketAcl = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketAcl",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?acl"
    },
    input: {
        shape: PutBucketAclInput_1.PutBucketAclInput
    },
    output: {
        shape: PutBucketAclOutput_1.PutBucketAclOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketAcl.js.map